import { Component,ViewChild, OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { AuthService } from '../auth.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HandlerService } from '../handler.service';
import { Platform } from '@ionic/angular';
import { MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ExcelService } from '../excel.service';
import { FormControl } from '@angular/forms';
import { Camera,CameraOptions } from '@ionic-native/camera/ngx';
import { DomSanitizer } from '@angular/platform-browser';
let k=1;

@Component({
  selector: 'app-new-manage-on-demand-request',
  templateUrl: './new-manage-on-demand-request.component.html',
  styleUrls: ['./new-manage-on-demand-request.component.scss'],
})
export class NewManageOnDemandRequestComponent{

  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // applyFilter(filterValue: string) {
  //   filterValue = filterValue.trim(); // Remove whitespace
  //   filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  //   this.dataSource.filter = filterValue;
  // } 
  loader: boolean = false;
  active1: boolean = false;
  id;
  url;
  newItems;
  search:any=[];
  filterLength;
  reasons;
  items = [];
  serviceInc: boolean;
  CalDate ;
  popLoad:boolean=false;
  customerPop: boolean;
  customerPopSearch: boolean;
  Cview: boolean = true;
  displayedColumns = ['id','custName','identificationNbr','make','model','place','region','service','payment','status'];
  dataSource: any; 
  pName;
  pColor;
  response;
  pMake;
  subsItems;
  pModel;
  dateFormat;
  statussearch:any=[];
  pIdentity;
  changeId;
  pDate:boolean=false;
  numb;
  check: boolean = false;
  send: boolean = false;
  imgView:boolean = false;
  status;
  contractors;
  cancellation;
  ChangeInc:boolean = false;
ContractorName;
openPopUp:boolean = false;
message:any;
filterPop:boolean = false;
filter:boolean ;
newCustPop:boolean;
resId;
reqID;
  payment = [ { id: 2, name: "Paid" }, { id: 1, name: "Not Paid" }]
  statusObj = [{ id: 1, name: "Pending" }, 
  { id: 9, name: "Assigned" },
  { id: 6, name: "Allocated" },  
  { id: 2, name: "Confirmed" },
  { id: 3, name: "Completed" },
  { id: 7, name: "Missed" },
  { id: 4, name: "Cancelled" },
  { id: 8, name: "Not In Place" }
 ]
  statusName;
  
  subs;
  category;
  confirm:boolean=false;
  clicked: boolean;
  cateName;
  advanceSearch:boolean=false;
  buttonName = "Show YB Only";
  paymentName;
  filterItems;
  mbv:boolean;
  custName;
  cancelId;
  trainerFetch: boolean = true;
  allItems: any = [];
  notifyItems: any = [];
  nameCheck: boolean = false;
  date=new Date();
  make;
  model;
  bikeNumber;
  serviceFlat;
  serviceStreet;
  serviceRegion;
  serviceName;
  carmodel;
  carmake;
  filterDate;
  reqStatusName;
  payStatusName;
  color;
  custItem;
  allocationOptions:any=[];
  optionName;
  optionId;
  orgs;
  orgName;
  cancelledReasons;  
  filItems;
  contDrop:boolean=false;
  cate1Id;
  userData:any;
  userCheck:boolean;
  cloneUsers:any=[];
  newItem:any=[];
  startdate=new Date();
  enddate=new Date(); 
  fDate;
  eDate; 
  orgId ;
  cateId;
  contractorId;
  statusId;
  paymentId;
  excelDataAll:any=[];
  excell:any=[];
  paymentDetail;
  clickedImage:any;
  nBlob:any;
  popImg;
  Type;
  fName;
  options: CameraOptions = {
    quality: 30,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE
  }
  idFilter = new FormControl('');
  bikeNumberFilter= new FormControl('');
  paymentStatusFilter =new FormControl('');
  serviceNameFilter= new FormControl('');
  serviceRegionFilter = new FormControl('');
  serviceFlatFilter = new FormControl('');
  carmodelFilter = new FormControl('');
  carmakeFilter = new FormControl('');
  custNameFilter = new FormControl('');
  statusFilter = new FormControl('');
  filterValues = {    
    id: '',
    bikeNumber: '',
    serviceFlat: '', 
    serviceRegion: '',
    serviceName:  '',
    carmodel:  '',
    serviceStreet:'',
    carmake:  '',
    custName: '',
    payStatusName:'',
    reqStatusName:''

  };
  missedData:any=[];
  searchShow:boolean=true;
  custmob;
  currentDate;
  missedCheck:boolean = false;
  missedId;
  missedValue;
  custname;
  phone;
  userChecke:boolean;
  constructor(public auth: AuthService, private router: Router, public handler: HandlerService,
    public service: ApiService, private bottomSheet: MatBottomSheet, private platform: Platform, private excelService: ExcelService,private camera: Camera,public sanitizer: DomSanitizer) { }

 
  ionViewWillEnter() { 
    sessionStorage.setItem('vendorApp','true');
    this.customerPopSearch=true;
    this.url = window.location.href; 
    this.idFilter.valueChanges
      .subscribe(
        id => {
          this.filterValues.id = id;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.bikeNumberFilter.valueChanges
      .subscribe(
        bikeNumber => {
          this.filterValues.bikeNumber = bikeNumber;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.paymentStatusFilter.valueChanges
      .subscribe(
        payStatusName => {
          this.filterValues.payStatusName = payStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.statusFilter.valueChanges
      .subscribe(
        reqStatusName => {
          this.filterValues.reqStatusName = reqStatusName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.serviceNameFilter.valueChanges
      .subscribe(
        serviceName => {
          this.filterValues.serviceName = serviceName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.serviceRegionFilter.valueChanges
      .subscribe(
        serviceRegion => {
          this.filterValues.serviceRegion = serviceRegion;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.serviceFlatFilter.valueChanges
      .subscribe(
        serviceFlat => {
          this.filterValues.serviceFlat = serviceFlat;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
         this.carmodelFilter.valueChanges
      .subscribe(
        carmodel => {
          this.filterValues.carmodel = carmodel;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.carmakeFilter.valueChanges
      .subscribe(
        carmake => {
          this.filterValues.carmake = carmake;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      this.custNameFilter.valueChanges
      .subscribe(
        custName => {
          this.filterValues.custName = custName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.dateFormat = this.auth.getDateformat();
    this.currentDate = this.returnDate(this.date);
    this.filter = false;
    sessionStorage.removeItem('employee')
    sessionStorage.removeItem('vendor')
    // this.loader = true;
    if (this.platform.is('ios') || this.platform.is('android')) {
     this.mbv=false;
    }
    else{
      this.mbv=true;
    }
    this.id = localStorage.getItem('organizationId');  
    this.getRequest(this.date);
    this.getCategory();
    this.getCancelReason();
    this.getDailyStatus();
    this.getChange();
    this.startDate();
    this.endDate();
    this.getMissedStaticData();
    // this.getsc();
  }

  getMissedStaticData() {
    this.service.getMissedData().subscribe((res: any) => {
      this.missedData = res;
    })
  }

  getChange(){
    this.service.getReasons().subscribe(res =>{ 
      this.reasons = res;
    }) 
  }

  assignVendor(data, id) {
    sessionStorage.setItem('catId', data.providerService.itemCategoryId)
    sessionStorage.setItem('employee', data.serviceContractorId)
    sessionStorage.setItem('vendor', data.vendorId)
    this.router.navigate(['/change-Alloc1/', +id]);
  }

  assignVendor1(data, id) {
    sessionStorage.setItem('catId', data.providerService.itemCategoryId)
    sessionStorage.setItem('employee', data.serviceContractorId)
    sessionStorage.setItem('vendor', data.vendorId)
    this.router.navigate(['/assign-employee1/', +id]);
  }
  

  getRequest(date){
    this.loader = true;   
    if(this.filterDate < this.date){
      this.pDate=true;
    }
    else{
      this.pDate=false;
    }
      this.buttonName = "Show YB Only";
      k=1; 
      this.service.getAllRequestByCategory(this.returnDate(date),k).subscribe((res: any) => {
        if (res) {
          res.map(dat=>{
            var a = dat.apptDate.split("T");
            Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
            var b = a[0].split("-");
            var c = b[1]+"/"+b[2]+"/"+b[0];
            var d = b[0]+"-"+b[1]+"-"+b[2];
            var todaysDate = new Date();
            var inputDate = new Date(c);
            var inputDate1 = new Date(d);
            if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
              Object.assign(dat,{present:true});
            }
            if(dat.custItem){
              if(dat.custItem.identificationNo != null ||dat.custItem.identificationNo != ""  ){
                Object.assign(dat,{bikeNumber:dat.custItem.identificationNo});
              }
            }
            
            if(todaysDate < inputDate1){ 
              Object.assign(dat,{present:true});
            }
          })
          this.filterItems = res;
          this.allItems = res;
          this.items = res;    
          this.custItem =res.custItem;  
          this.items.map(res => {
            Object.assign(res, { clicked: false })
          })
          this.items.map(res=>{
            Object.assign(res,{contactNbrMob:res.requestor.contactNbrMob})
          })         
            this.items.map(res1 => {
              if(res1.custItem)
              Object.assign(res1, { bikeNumber: res1.custItem?.identificationNo, carmake:res1.custItem?.make, carmodel:res1.custItem?.model})
              if(res1.address)
              Object.assign(res1, {serviceRegion:res1.address?.regionId})
              if(res1.providerService)
              Object.assign(res1, {serviceName:res1.providerService?.name})
              if(res1.paymentStatus==1)
              Object.assign(res1, {payStatusName: "Not Paid"})
              if(res1.paymentStatus==2)
              Object.assign(res1, {payStatusName: "Paid"})
              if(res1.address?.appt==true)
              Object.assign(res1, {serviceFlat:res1.address?.flatName})
              if(res1.address?.appt==false)
              Object.assign(res1, {serviceFlat:res1.address?.street})
              if(res1.address?.appt=="" || res1.address?.appt== undefined )
              Object.assign(res1, {serviceFlat:"Not Specified"})
            })  
       
           this.getOrgs(); 
           this.matTableData(date);
           k++;   
        } else {
          // this.subsItems=[];
          this.items = [];
          this.handler.res("No Data Found");
          this.getOrgs();    
        }
      }, err => {
        this.loader = false;
        this.handler.err(err);
      })
  
  }

  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')
    
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.id.toString().toLowerCase().indexOf(searchTerms.id) !== -1 
      && data.bikeNumber.toString().toLowerCase().indexOf(searchTerms.bikeNumber) !== -1
      && data.custName.toString().toLowerCase().indexOf(searchTerms.custName) !== -1
      && data.carmake.toString().toLowerCase().indexOf(searchTerms.carmake) !== -1
      && data.carmodel.toString().toLowerCase().indexOf(searchTerms.carmodel) !== -1
      && data.serviceName.toString().toLowerCase().indexOf(searchTerms.serviceName) !== -1   
      && data.serviceRegion.toString().toLowerCase().indexOf(searchTerms.serviceRegion) !== -1   
      // && data.serviceFlat.toString().toLowerCase().indexOf(searchTerms.serviceFlat) !== -1
      && data.payStatusName.toString().toLowerCase().indexOf(searchTerms.payStatusName) !== -1
      && data.reqStatusName.toString().toLowerCase().indexOf(searchTerms.reqStatusName) !== -1
    }
    return filterFunction;
  }

  Vendorselect1(data, id) {
    sessionStorage.setItem('catId', data.providerService.itemCategoryId)
    this.router.navigate(['/assignVendor/', +id]);
    window['appointmentObj'] = data;
  }

  mess(){
    this.service.getPaymentRemainderMsg().subscribe((res:any)=>{
      this.message=res.notifications;
    })  
    this.openPopUp = true;
  }
 

  changeVendorselect1(data, id) {
    sessionStorage.setItem('catId', data.providerService.itemCategoryId)
    sessionStorage.setItem('vendor', data.vendorId)
    this.router.navigate(['/changeAssignVendor/', +id]);
    window['appointmentObj'] = data;
  }

  openPop(data) {
    this.serviceInc = true
    if(data.custItem){
      this.pName = data.providerService.name;
      this.pColor = data.custItem.colour;
      this.pMake = data.custItem.make;
      this.pModel = data.custItem.model;
      this.pIdentity = data.custItem.identificationNo; 
    }
 
  }



  getId(data) {

    if (data.custItem) {
      if (data.custItem) {
        return data.custItem?.identificationNo
      }
    }else{
      return data.identificationNumber
    }
  }

  openBottomSheet() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id; 
      }
    });
  }

 

  getCategory() {
    this.service.getOrgCategory().subscribe((res: any) => {
      this.category = res;
      this.getsc1();
    })
  }


  showActiveData() {
    this.loader = true;
    // var userId=localStorage.getItem('currentUserId'); 
    if (this.buttonName == "Show YB Only") {
      this.buttonName = "Show All"
      this.items = this.allItems.filter(res => { return res.vendorId == 790 });
      this.filterItems = this.items;
    } else {
      this.buttonName = "Show YB Only"
      this.items = this.allItems;
      this.filterItems = this.items;
    }

    setTimeout(() => {
      this.loader = false;
    }, 1000);
  }

  openBottomSheetstatus() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.payment,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.paymentName = res.name;
        this.paymentId = res.id;     
      }
    })
  }

  openBottomSheetCheck() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.statusObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.statusName = res.name;
        this.statusId = res.id;
        this.statusFilters(this.statusId)
      }
    })


  }

  getOrgs(){
    this.service.getOrg().subscribe((res:any)=>{
      this.orgs=res;
      this.loader = false;
    })
  }


  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.orgs,
    });
    dialogRef.afterDismissed().subscribe((res:any) => {
      if(res){
        this.loader=true;
        this.orgName = res.name;
            this.orgId=res.id;             
            this.contDrop = true;       
            this.getsc();     
       
      }
      
    });
  }

  notify(){
    // this.send = true;
    // this.check = true;
    this.items.map(res=>
      res.clicked=false)

    if(!this.send){
      this.send = true;
    }else{
      this.send = false;
    }

    if(!this.check){
      this.check = true;
    }else{
      this.check = false;
    }
  }


  triggerChange(data) {
    if (this.send) {
      data.clicked = !data.clicked
      // if(data.clicked){
      //  let duplicate= this.notifyItems.find(res=>res==data.id);
      //  if(!duplicate)
      //  this.notifyItems.push(data.id)
      // }
      this.notifyItems = this.items.filter(res => res.clicked)
    }

  }

  sendNot(){ 
    this.notifyItems.map(res=>{
      this.loader = true;
      var post={
        "notifications":this.message
      }
      this.service.sendReqNotification(res.id,post).subscribe((res1:any)=>{
       res.clicked = false;
       this.send = false;
       this.openPopUp = false;
       this.loader = false;
       this.check = false;
      },err=>{
        res.clicked = false;
        this.handler.err(err)
        this.send = false;
        this.openPopUp = false;
        this.loader = false;
        this.check = false;
      })
    })
  }


 
  searchCust() {
        this.router.navigate(['/single-request/' + this.userData.userId]);
  }
   
      
searchCust1(){
  this.handler.error("Customer is not registered.Please register");
   var num1 = /^[0-9]+$/
   if(this.custName.match(num1)){
   sessionStorage.setItem('mobile#', this.custmob);
   this.router.navigate(['/newCustomerService'])
   }else{
   sessionStorage.setItem('firstName', this.custName);
   this.router.navigate(['/newCustomerService'])
     }
   }
   
    



getUser(val) { 
  let x = val.length;
  if(x > 2){
    this.cloneUsers = [];
   this.service.searchCustomers("CUST",val,this.id).subscribe((res: any) => {
     if(res != null && res != "NO_CONTENT" && res.length > 0){
      this.userChecke=true;  
      this.cloneUsers =JSON.parse(JSON.stringify(res));
      if(!this.custName){
        this.cloneUsers = [];
      }
     }else{
       this.cloneUsers = [];
       this.cloneUsers.push({
        userId:1,
        firstName:'Create New Customer'
       })   
     }      
   })
  }else{
    this.cloneUsers=[];
    this.userChecke=false;
  }
}

getCusData(data){
this.userData = data;
if(data.userId==1){
  this.customerPop=false;
 this.newCustPop=true;
}
this.userCheck = true;
}
  createNew(){
    this.router.navigate(['/newCustomerService'])
    this.customerPopSearch=false;
    sessionStorage.setItem('firstName', this.custName)  
  }

  customerDetail(id){
    this.router.navigate(['single-request/' + id]);
    this.customerPopSearch=false;
  }

 

  close() {
    this.customerPop = false;
    this.numb = "";
    this.custName="";
  }

  close1() {
    this.customerPopSearch = false;
  }

  ionViewWillLeave() {
    this.numb = "";
    this.customerPop = false;
    this.nameCheck = false;
    this.search = "";
    this.custName = "";
    this.cloneUsers="";
    this.fName="";
    this.userCheck=false;
  }

  cancel(id){
    this.cancelId = id;
    this.confirm=true;
  }

  cancelPop(){
    this.confirm = false;
   this.cancelReq();
 }

  cancelReq(){
    this.loader = true;
    var post={
      "cancellationReasons":this.cancellation
    }
    this.service.cancelReq(this.cancelId,post).subscribe((res: any) => {
      this.handler.res("Request Cancelled successfully");
      this.confirm =false;
      this.loader=false;
     this.getRequest(this.date);
     this.matTableData(this.date)
         })
  }

  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();
   return year + '-' + month + '-' + date; 
 }

 
 Allocations(data,id) {
  if(data.status == 1  && (this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))){
    this.allocationOptions = [{ id: 0, name: "Assign Vendor" },{ id: 4, name:"Customer Payment"}]
  }
  if(data.status == 9  && (this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))){
    this.allocationOptions = [{ id: 1, name: "Assign Employee" },  { id: 2, name: "Change Vendor" },{ id: 4, name:"Customer Payment"}]
  }
  if(data.status == 2   && (this.auth.checkCapability('FSA')||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))){   
 
    this.allocationOptions = [{ id: 2, name: "Change Vendor" },{ id: 3, name: "Change Allocation" },{ id: 4, name:"Customer Payment"}]
  }
  if(data.status == 2  && !this.auth.checkCapability('FSA')  && this.auth.checkCapability('SP')   ){

    this.allocationOptions = [{ id: 3, name: "Change Allocation" }]
  }
  if(data.status == 6 && (this.auth.checkCapability('FSA')  || this.auth.checkCapability('SP') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP') )  ){
    this.allocationOptions = [{ id: 2, name: "Change Vendor" },{ id: 3, name: "Change Allocation" },{ id: 4, name:"Customer Payment"},{id:5,name:"Accept Request"}]
  }
  if((data.status == 3 || data.status == 7 || data.status == 8) && (this.auth.checkCapability('FSA')  || this.auth.checkCapability('SP') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP') )  ){
    this.allocationOptions = [{ id: 4, name:"Customer Payment"}]
  }
  
  if(data.status == 9 && !this.auth.checkCapability('FSA')  && this.auth.checkCapability('SP')   ){
    this.allocationOptions = [{ id: 1, name: "Assign Employee" }]
  }
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.allocationOptions,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.optionName = res.name;
        this.optionId = res.id;     
    if(this.optionId==0){
      this.Vendorselect1(data,id); 
    }
    if(this.optionId==2){
      this.changeVendorselect1(data, id); 
    }
    if(this.optionId==1){
      this.assignVendor1(data,id); 
    }
    if(this.optionId==3 ){
      this.assignVendor(data,id); 
    }
    if(this.optionId==4){
      this.pay(data.customerInvoiceId,data.id,data)
    }
    if(this.optionId==5){
      this.accept(data);
    }
      }
    });
  }
  accept(data){
    this.loader = true;
    this.url = window.location.href;
      let post = {
      "apptDate":data.apptDate,
      "serviceContractorId": data.serviceContractorId,
      "targetSource": data.serviceContractorId,
      "apptEndTime":data.apptEndTime,
      "apptTime":data.apptTime,
      }
    
    let url = window.location.href;   
      this.service.confirmEmpReq(data.id,post).subscribe(res => {
       this.loader = false;
       this.getRequest(this.date);
        this.handler.res('Request Confirmed Successfully !!');
        // this.router.navigate(['/vendor-request']);    
         
    })
  }
  
filterReq(){
  this.filterPop = true;
}

getsc1(){
  this.service.getUsersByOrg('SC',this.id,null).subscribe((res:any) => { 
    this.contractors=res;   
  this.contractors= res.filter(res =>{return res.reqRoleApproved == true});
 
},err=>{
this.handler.err(err)
})
}

  getsc(){
    this.loader = true;
    this.filterPop = false;   
    this.service.getUsersByOrg('SC',this.orgId,null).subscribe((res:any) => { 
      if(res){
        this.contractors=res;
        if(this.contractors && this.contractors.length > 0){
          this.contractors.sort(function (a, b) {
            var nameA = a.firstName, nameB = b.firstName;
            if (nameA < nameB) { return -1; }
            if (nameA > nameB) { return 1; }
            return 0;
          })
        }
      this.contractors.map(res=>{
        if(res.categoryLists)
        res.categoryLists.map(res1=>{     
         if(res1.categoryId == this.cateId){
         this.cate1Id = res1.categoryId
         Object.assign(res,{vId:this.cate1Id})      
         }
        })
      })
      this.contractors= this.contractors.filter(res =>{return res.reqRoleApproved==true && res.vId==this.cateId });
    // this.contractors= res.filter(res =>{return res.reqRoleApproved == true});
    this.loader = false;
    this.filterPop = true;
      }else{
        this.loader=false;
       this.contractors=[];
       this.filterPop = true;
       
      }
},err=>{
  this.handler.err(err)
})
}

  openBottomSheetCon(): void {
    localStorage.setItem('showBar','true')
    if(!this.active1&&this.orgName){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.contractors,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.statusName = ""
      this.contractorId = res.userId;
      if(res.lastName)
      this.ContractorName = res.firstName ;
      else
      this.ContractorName = res.firstName;
    });
  }else{
    this.handler.staticError('Please select organisation')
  }
  }
  
  openBottomSheetCon1(): void {
    localStorage.setItem('showBar','true')
    if(!this.active1&&this.orgName){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.contractors,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.statusName = ""
      this.contractorId = res.userId;
      if(res.lastName)
      this.ContractorName = res.firstName ;
      else
      this.ContractorName = res.firstName;
    });
  }else{
    this.handler.staticError('Please select organisation')
  }
  }


  cancelFilter() {
    this.loader = true;
    this.statusName = "";
    this.reqID="";
    this.custname="";
    this.phone="";
    this.statussearch=[];
    this.statusId =undefined;
    this.contractorId = undefined;
    this.ContractorName = "";
    this.paymentName = "";
    this.paymentId = undefined;
    this.cateName="";
    this.cateId=undefined;
    this.orgName = "";
    this.orgId = undefined;
    this.filterPop = false;
    this.contDrop = false;
    this.filter = false;
    this.getRequest(this.date)
    this.matTableData(this.date)
  }

  searchfilter(){
    var statusId=[]
    this.filter = true;
    this.loader = true;
    this.statussearch.map(res=>{
      statusId.push(res.id)
     }) 
    let post={
      "id" : this.reqID,
      "fromDate": this.fDate,
      "toDate": this.eDate,
      "serviceContractorId": this.contractorId,
      "vendorId": this.orgId,
      "statuses" :statusId,
      "paymtStatus": this.paymentId,
      "categoryId" : this.cateId,
    }
    this.service.getAppointReq2(post).subscribe((res:any)=>{
     if(res){
      this.items = res;
      if(this.phone){
        this.items = this.items.filter(dat=>{ return dat.requestor.contactNbrMob == '+91'+this.phone})
        }
        if(this.custname){
          this.items = this.items.filter(dat=>{ return dat.requestor.firstName == this.custname})
          }
      this.items.map(res => {
        Object.assign(res, { clicked: false })
      })
      this.items.map(res=>{
        Object.assign(res,{contactNbrMob:res.requestor.contactNbrMob})
      })          
      this.items.map(res1 => {
        if(res1.custItem)
        Object.assign(res1, { bikeNumber: res1.custItem?.identificationNo, carmake:res1.custItem?.make, carmodel:res1.custItem?.model})
        if(res1.address)
        Object.assign(res1, {serviceRegion:res1.address?.regionId})
        if(res1.providerService)
        Object.assign(res1, {serviceName:res1.providerService?.name})
        if(res1.paymentStatus==1)
        Object.assign(res1, {payStatusName: "Not Paid"})
        if(res1.paymentStatus==2)
        Object.assign(res1, {payStatusName: "Paid"})
        if(res1.address?.appt==true)
        Object.assign(res1, {serviceFlat:res1.address?.flatName})
        if(res1.address?.appt==false)
        Object.assign(res1, {serviceFlat:res1.address?.street})
        if(res1.address?.appt=="" || res1.address?.appt== undefined )
        Object.assign(res1, {serviceFlat:"Not Specified"})
        if(res1.status==1)
        Object.assign(res1, {reqStatusName:"Pending"})
        if(res1.status==2)
        Object.assign(res1, {reqStatusName:"Confirmed"})
        if(res1.status==3)
        Object.assign(res1, {reqStatusName:"Completed"})
        if(res1.status==4)
        Object.assign(res1, {reqStatusName:"Cancelled"})
        if(res1.status==6)
        Object.assign(res1, {reqStatusName:"Allocated"})
        if(res1.status==7)
        Object.assign(res1, {reqStatusName:"Missed"})
        if(res1.status==8)
        Object.assign(res1, {reqStatusName:"Not In Place"})
        if(res1.status==9)
        Object.assign(res1, {reqStatusName:"Assigned"})
      })        
      this.dataSource = new MatTableDataSource(this.items); 
      this.dataSource.filterPredicate = this.createFilter(); 
      this.dataSource.sort = this.sort;
        
      this.loader = false;
     }else{
       this.loader=false;
       this.items=[];
       this.handler.res("No Data Found");
     }   
    }, err => {
      this.loader = false;
      this.filterPop = true;
      this.handler.err(err);
    })
  }
  
  next() {
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let newDate = new Date(x.setDate(x.getDate() + 1));
    this.date = newDate;
    k=1;
    this.getRequest(this.date)
    this.matTableData(this.date)
  }
  
  prev() {  
    let x = new Date(JSON.parse(JSON.stringify(this.date)));
    let newDate = new Date(x.setDate(x.getDate() - 1));
    this.date = newDate
    k=1;
    this.getRequest(this.date)
    this.matTableData(this.date)
  }

  refreshData(event){ 
      this.ionViewWillEnter();  
  }

  pay(id, id1,data) {
      this.router.navigate(['/review-invoice-reqs/' + id]);
      sessionStorage.setItem('serviceId', id1)
      sessionStorage.setItem('status',data.paymentStatus)  
  }
  clear(){
    this.search="";
  }

  requestByPage($event,date){
    if(!this.filter&&this.search.length==0){
      this.clear();
        this.service.getAllRequestByCategory(this.returnDate(date),k).subscribe((res: any) => {
          res.map(dat=>{
            var a = dat.apptDate.split("T");
            Object.assign(dat,{date:a[0],present:false,custFirstName:dat.requestor?.firstName,custLastName:dat.requestor?.lastName});
            var b = a[0].split("-");
            var c = b[1]+"/"+b[2]+"/"+b[0];
            var d = b[0]+"-"+b[1]+"-"+b[2];
            var todaysDate = new Date();
            var inputDate = new Date(c);
            var inputDate1 = new Date(d);
            if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
              Object.assign(dat,{present:true});
            }
            if(dat.custItem){
              if(dat.custItem.identificationNo != null ||dat.custItem.identificationNo != ""  ){
                Object.assign(dat,{bikeNumber:dat.custItem.identificationNo});
              }
            }
            
            if(todaysDate < inputDate1){ 
              Object.assign(dat,{present:true});
            }
          })
          res.map(dat=>{
            this.items.push(dat);
          })        
          this.items.map(res => {
            Object.assign(res, { clicked: false })
          })         
          this.items.map(res1 => {
            if(res1.custItem)
            Object.assign(res1, { bikeNumber: res1.custItem?.identificationNo, carmake:res1.custItem?.make, carmodel:res1.custItem?.model})
            if(res1.address)
            Object.assign(res1, {serviceFlat:res1.address?.flatName,serviceStreet:res1.address?.street,serviceRegion:res1.address?.regionId})
            if(res1.providerService)
            Object.assign(res1, {serviceName:res1.providerService?.name})
          })   
     
          this.loader = false;
          k++;
        },err=>{
          this.loader = false;
        })
    
    }
  
    }
    getCancelReason(){
      this.service.getcancellationReason().subscribe(res =>{ 
        this.cancelledReasons = res;
      }) 
    }

    clearArray2(value){
      this.cancellation=value.name;
    }


    viewChange(id) {
      if (id == 1) {
         this.Cview = true;
         this.searchShow = true;  
         this.getRequest(this.date);  
        }
      else {
        this.Cview = false;
        this.searchShow = false;
        this.matTableData(this.date);
       }
    }

    exportAsXLSX(){
      this.items.map(res =>{
        this.payment.map(res1=>{
          if(res.paymentStatus ==res1.id){
            Object.assign(res,{paymentDetail:res1.name})           
          }
        })
         
        this.excelDataAll.push({
          RequestId:res.id,IdentificationNo:res.custItem?.identificationNo,CustomerName:res.custName,FlatName:res.address?.flatName,Street:res.address?.street,Make:res.custItem?.make,Model:res.custItem?.model,Colour:res.custItem?.colour,
          Services:res.providerService?.name,Payment:res.paymentDetail
        })
      })
      this.excelService.exportAsExcelFile(this.excelDataAll, 'Request Details');
     
    this.excelDataAll=[]
    }

  matTableData(date){
    this.loader = true;   
    if(this.filterDate < this.date){
      this.pDate=true;
    }
    else{
      this.pDate=false;
    }

    if (this.id == 790) {
           this.service.getAllRequestForMatTable(this.returnDate(date)).subscribe((res: any) => {
        if (res) {
          this.filterItems = res;
          this.allItems = res;
          this.items = res;    
          this.custItem =res.custItem;  
          this.items.map(res => {
            Object.assign(res, { clicked: false })
          })         
            this.items.map(res1 => {
              if(res1.custItem)
              Object.assign(res1, { bikeNumber: res1.custItem?.identificationNo, carmake:res1.custItem?.make, carmodel:res1.custItem?.model})
              if(res1.address)
              Object.assign(res1, {serviceRegion:res1.address?.regionId})
              if(res1.providerService)
              Object.assign(res1, {serviceName:res1.providerService?.name})
              if(res1.paymentStatus==1)
              Object.assign(res1, {payStatusName: "Not Paid"})
              if(res1.paymentStatus==2)
              Object.assign(res1, {payStatusName: "Paid"})
              if(res1.address?.appt==true)
              Object.assign(res1, {serviceFlat:res1.address?.flatName})
              if(res1.address?.appt==false)
              Object.assign(res1, {serviceFlat:res1.address?.street})
              if(res1.address?.appt=="" || res1.address?.appt== undefined )
              Object.assign(res1, {serviceFlat:"Not Specified"})
              if(res1.status==1)
              Object.assign(res1, {reqStatusName:"Pending"})
              if(res1.status==2)
              Object.assign(res1, {reqStatusName:"Confirmed"})
              if(res1.status==3)
              Object.assign(res1, {reqStatusName:"Completed"})
              if(res1.status==4)
              Object.assign(res1, {reqStatusName:"Cancelled"})
              if(res1.status==6)
              Object.assign(res1, {reqStatusName:"Allocated"})
              if(res1.status==7)
              Object.assign(res1, {reqStatusName:"Missed"})
              if(res1.status==8)
              Object.assign(res1, {reqStatusName:"Not In Place"})
              if(res1.status==9)
              Object.assign(res1, {reqStatusName:"Assigned"})
            })             
            this.dataSource = new MatTableDataSource(this.items);       
            this.dataSource.sort = this.sort;
            this.dataSource.filterPredicate = this.createFilter(); 
           this.getOrgs();      
        } else {
          this.dataSource=[];    
          this.items = [];
          this.handler.res("No Data Found");
          this.getOrgs();    
        }
      }, err => {
        this.loader = false;
        this.handler.err(err);
      })
    } else {
      this.service.getAllSinRequestStatusMatTable(this.id,this.returnDate(date)).subscribe((res: any) => {
        if (res) {
          this.items = res;    
          this.items.map(res1 => {
            if(res1.custItem)
            Object.assign(res1, { bikeNumber: res1.custItem?.identificationNo, carmake:res1.custItem?.make, carmodel:res1.custItem?.model})
            if(res1.address)
            Object.assign(res1, {serviceRegion:res1.address?.regionId})
            if(res1.providerService)
            Object.assign(res1, {serviceName:res1.providerService?.name})
            if(res1.paymentStatus==1)
            Object.assign(res1, {payStatusName: "Not Paid"})
            if(res1.paymentStatus==2)
            Object.assign(res1, {payStatusName: "Paid"})
            if(res1.address?.appt==true)
            Object.assign(res1, {serviceFlat:res1.address?.flatName})
            if(res1.address?.appt==false)
            Object.assign(res1, {serviceFlat:res1.address?.street})
            if(res1.address?.appt=="" || res1.address?.appt== undefined )
            Object.assign(res1, {serviceFlat:"Not Specified"})
            if(res1.status==1)
            Object.assign(res1, {reqStatusName:"Pending"})
            if(res1.status==2)
            Object.assign(res1, {reqStatusName:"Confirmed"})
            if(res1.status==3)
            Object.assign(res1, {reqStatusName:"Completed"})
            if(res1.status==4)
            Object.assign(res1, {reqStatusName:"Cancelled"})
            if(res1.status==6)
            Object.assign(res1, {reqStatusName:"Allocated"})
            if(res1.status==7)
            Object.assign(res1, {reqStatusName:"Missed"})
            if(res1.status==8)
            Object.assign(res1, {reqStatusName:"Not In Place"})
            if(res1.status==9)
            Object.assign(res1, {reqStatusName:"Assigned"})
          })    
          this.dataSource = new MatTableDataSource(this.items); 
          this.dataSource.filterPredicate = this.createFilter();     
          this.dataSource.sort = this.sort;
          this.loader = false;        
        } else {   
          this.dataSource=[];  
          this.items = [];
          this.handler.res("No Data Found");
          this.loader = false;
        }
      }, err => {
        this.loader = false;
        this.handler.err(err);
      })
    } 
  }
  
  startDate(){
    console.log(this.startdate)
    this.fDate=this.returnDate(this.startdate);
  }
  endDate(){
    this.eDate=this.returnDate(this.enddate);
  }
  getMissed(id){
    this.missedId = id;
    this.missedCheck = true ;
  }
  Missed(){
    this.loader = true;
    this.missedCheck = false;
    let y = this.status.find(res => res.name == "Missed");
    let a =y.id;
    let post = {
      "id":this.missedId,
      "status": a,
      "missedReasons":this.missedValue
      }
    this.service.missed(post ,this.missedId).subscribe((res:any)=>{
      sessionStorage.setItem("clickValue",this.missedId)
      this.handler.res('Status Updated Successfully !!')
      this.missedCheck=false;
      this.getRequest(this.date)
    },
    err=>{
      this.loader=false;
      this.handler.err(err)
    })
  }
  clearArray1(value){
    this.missedValue=value.id;
  }
  clearArray(value){
    this.changeId=value.id;
  }
  captureImage(id) {
    if (this.platform.is('android') || this.platform.is('ios')){
      this.camera.getPicture(this.options).then((imageData:any) => {
        if(imageData){
          let base64Image = 'data:image/jpeg;base64,' + imageData;
          this.clickedImage = base64Image;
          this.NotInPlace(id);
        }else{
          console.log('ddd')
          this.blobData(id)
        }     
      }); 
    }else{
      console.log('kakakk')
      this.blobData(id)
      }
  }
  NotInPlace(id){
    this.loader=true;
    let y = this.status.find(res => res.name == "NotInPlace");
    let a =y.id;
    var file
    if (this.platform.is('android') || this.platform.is('ios')){
       file = this.DataURIToBlob(this.clickedImage)
    }else{
       file = this.nBlob;
    }
    setTimeout(() => {
      this.service.notInPlace(id,a,file).subscribe((res:any)=>{
        sessionStorage.setItem("clickValue",id)
        this.handler.res('Status Updated Successfully !!')
         this.getRequest(this.date)
         },
      err=>{
        this.loader=false;
        this.handler.err(err)
      })
    }, 1000);
   
  }
  blobData(id){
    console.log(id)
    var xhr = new XMLHttpRequest();       
    xhr.open("GET", "assets/icon/seden.jpeg", true); 
    xhr.responseType = "blob";
    var obj=this;
    xhr.onload = function (e) {
    var reader = new FileReader();
    reader.onload = function(event) {
        var res = event.target.result;
    }
    obj.nBlob = this.response;
    reader.readAsDataURL(obj.nBlob);
    obj.NotInPlace(id);
    };
    xhr.send() 
  }
  DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)
    return new Blob([ia], { type: mimeString })
  }
  Completed(id){
    console.log(id)
    this.loader = true;
    console.log(this.status)
    let y = this.status.find(res => res.name == "Completed");
    console.log(y)
    let a =y.id;
    let post = {
      "id":id,
      "status": a,
     }
       this.service.completed(post,id).subscribe((res:any)=>{
      sessionStorage.setItem("clickValue",id)
      this.handler.res('Status Updated Successfully !!')
      this.getRequest(this.date)
      // this.loader=false;
    },
    err=>{
      this.loader=false;
      this.handler.err(err)
    })
  }
  getDailyStatus(){
    this.service.getDailyStatus().subscribe(res =>{ 
      this.status = res;
    }) 
  }
  getImage(id){
    this.loader = true;
    this.service.getDocumentImg(id).subscribe(res=>{  
         this.popImg= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
         this.imgView = true;
         this.loader = false;
       },err =>{
         this.loader = false;
         this.handler.err(err); 
       })
  }
  getReason(id){
    this.resId=id;
    this.ChangeInc=true;
  }

  clearCapture(){
    this.clickedImage = ""
    this.ChangeInc = false;
    this.updateReason();
  }

  updateReason(){
    this.loader=true;
    let post = {
      "id":this.resId,
      "status": 2,
      "reason":this.changeId  
    }
    this.service.updateReasons(post,this.resId).subscribe((res:any)=>{
      this.handler.res('Status Updated Successfully !!')
        this.getRequest(this.date)
        this.Type="";
      // this.loader=false;
  
    },
    err=>{
      this.loader=false;
      this.handler.err(err)
    }) 
  }
  markedTime(value){
    if(value){
      var x = value.split("T");
      var y = x[1].slice(0, 5);
      return y
    }
  }
  convertTime(tim){
    var time;
    time = tim.split(":");
    return time[0]+":"+time[1]
  }
  removeChip(i) {
    this.statussearch.splice(i, 1);
  }
  statusFilters(id){
    let statusType: any = [];
      statusType = this.statusObj.filter(res => { return res.id == id })
      this.statussearch.push(statusType[0])
      this.statussearch = this.statussearch.filter((x, i, a) => a.indexOf(x) == i);
  }
  closePop(){
    this.imgView=false;
    this.popImg = undefined;
   }
   advanced(){
    this.advanceSearch=true;
  }
  register() {
    this.popLoad=true;
  
    if(this.fName && this.numb!=""){
    if (this.fName &&  this.numb)
    if(this.numb.length==10){
    if(this.fName){
      this.fName = this.fName.toUpperCase();
    }
      var post = {
        contactNbrMob: '+91'+ this.numb,
        firstName: this.fName,
        userType: 1,
        orgCode:'YB',
        genderCd:1,
        appId: 14,
        roles: ['CUST'],
      }
        Object.assign(post,{paless: true})   
    this.loader = true;
    this.service.register(post).subscribe(
      (res: any) => {
        if(res){
          this.newCustPop=false;
          sessionStorage.setItem('userId',res.userId)
          if(this.url.includes('vendor-manage-order'))
          this.router.navigate(['/homeCategories']);
          else
          this.router.navigate(['/newCategories']);
          this.handler.res('Registered Successfully !!')   
          this.popLoad = false;
        }
      },
      err => {
        this.handler.err(err);
        this.popLoad = false;
      })
    }else{
      this.handler.staticError("Please Enter Valid Mobile number")
      this.popLoad=false;
    }
     }
    else{
      this.popLoad=false;
      this.handler.res("Please Enter The phone number and name");
    }
  }

}
